import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { ForeignLanguageResponse } from "../../models/dtos";

export const foreignLanguagesApi = createApi({
  reducerPath: "foreignLanguagesApi",
  baseQuery: baseAuthQuery("ForeignLanguages"),
  tagTypes: ["ForeignLanguages"],
  endpoints: (builder) => ({
    getForeignLanguages: builder.query<ApiResponse<ForeignLanguageResponse[]>, number>({
      query: (studentId) => `adminapp/${studentId}`,
      providesTags: ["ForeignLanguages"],
    }),
  }),
});
